import { NgbDate } from '@ng-bootstrap/ng-bootstrap';
import { AbstractControl, FormArray } from "@angular/forms";
import { ParameterExceptions } from './constantes';

export class HelperFunctions {
    /**
   * A function that set the error clas if the control is invalid
   * @returns {string}
   */
    public static controlIsInvalid(control: AbstractControl): boolean {
        return (control?.invalid && (control?.dirty || control?.touched))
    }

    /**
    * A function that remove all entries in form array
    * @param {FormArray} formArray
    * @returns {void}
    */
    public static resetFormArray(formArray: FormArray): void {
        while (formArray.length !== 0) {
            formArray.removeAt(0);
        }
    }

    /**
    * A function that checks if it is a mobile device
    * @returns {boolean}
    */
    public static isMobile(): boolean {
        return window.innerWidth <= 768;
    }

    /**
    * Get the map value
    * @param {string} status
    * @param {Map<string, string>} map
    * @returns {string}
    */
    public static getMapValue(status: string, map: Map<string, string>): string {
        const newStatus = map.get(status);
        return newStatus ? newStatus : status;
    }
    /** Transform ngbdate to string
     *  @param {NgbDate} date
     */
    public static getStringOfNgbDate(date: NgbDate): string {
        const formatDate = new Date(date.year, date.month - 1, date.day);
        const year = formatDate.toLocaleString('default', { year: 'numeric' });
        const month = formatDate.toLocaleString('default', { month: '2-digit' });
        const day = formatDate.toLocaleString('default', { day: '2-digit' });

        return [year, month, day].join('-');
    }

    public static getNgDate(value?: string) {
        let ngDate = null;
        if (value) {
            const date = new Date(value);
            ngDate = new NgbDate(date.getFullYear(), date.getMonth() + 1, date.getDate() + 1)
        }
        return ngDate;
    }

    /**
    * Validates if the parameter is SYSTEM_USER
    * @param {string} paramName
    * @returns {boolean}
    */
    public static validateSystemUser(paramName: string): boolean {
        return paramName === ParameterExceptions.SYSTEM_USER;
    }

  /**
   * This method sorts the reports by name property
   * @param {[]} reports
   * @param {string} property
   * @returns {[]}
   */
  public static sortByName(reports: any[], property: string): any[] {
    reports.sort((a, b) => {
        if (a[property] != null && b[property] != null) {
            let reportA = (a[property] as string).toLowerCase();
            let reportB = (b[property] as string).toLowerCase();
            if (reportA < reportB) { return -1; }
            if (reportA > reportB) { return 1; }
            return 0;
        } else {
            return 0;
        }
      });
    return reports;
  }

}